<ion-header>
  <ion-toolbar [color]="ionicColor" [ngStyle]="toolbarStyle">

    <ion-buttons slot="start">
      @if (!hasBackButton) {
        <ion-menu-button menu="m1" [style.color]="effectiveColor ? '#ffffff' : null" />
      }
      @if (hasBackButton) {
        <ion-back-button
          data-cy="app-header-back-button"
          [defaultHref]="backDefaultHref"
          style="color: #ffffff"
          text=""
          />
      }
    </ion-buttons>
    <ion-title [style.color]="effectiveColor ? '#ffffff' : null">{{ title }}</ion-title>
    @if (topRightButton) {
      <ion-buttons slot="end">
        <ion-button (click)="emitClick()" [disabled]="topRightButtonDisabled" [style.--color]="effectiveColor ? '#ffffff' : null">
          <ion-icon [name]="topRightButton" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>
